import { Toaster as HotToaster } from 'react-hot-toast';
import { DS_TOAST_MS } from '@/lib/designTokens';

/**
 * Dark toast, bottom-right, 6 s. Stays while hovered or focused.
 * Modules import { toast } from `react-hot-toast`.
 */
export function Toaster() {
  return (
    <HotToaster
      position="bottom-right"
      containerClassName="hv-toast"
      toastOptions={{
        duration: DS_TOAST_MS,
        style: {
          background: 'var(--toast-bg)',
          color: 'var(--toast-ink)',
          border: '1px solid var(--toast-line)',
          borderRadius: '12px',
          maxWidth: '420px',
          fontFamily: 'var(--font-sans)',
          fontSize: '14px',
          lineHeight: '20px',
          boxShadow: 'var(--sh-pop)',
          padding: '12px 12px 12px 16px',
        },
        success: {
          iconTheme: { primary: 'var(--toast-ok)', secondary: 'var(--toast-bg)' },
        },
        error: {
          iconTheme: { primary: 'var(--toast-err)', secondary: 'var(--toast-bg)' },
        },
      }}
    />
  );
}
